import React from 'react';
import { SelfServeBuilderPopupTypes } from 'Popups';
import PropTypes from 'prop-types';
import ToolItem from './ToolItem';

const SignatureToolItem = props =>
  <ToolItem
    imgSrc="/images/self-serve-builder/toolbox/signature-icon-inactive-2x.png"
    imgSrcHover="/images/self-serve-builder/toolbox/signature-icon-active-2x.png"
    title="SIGNATURE"
    description="Recipient signs document"
    tooltipClassName="signature"
    tooltipName={props.tooltipName}
    toolboxRef={props.toolboxRef}
    tooltipDescription={(
      <span>
        Use this when you want the recipient to sign your document.
      </span>
    )}
    tooltipExample={(
      <div className="tool-item-tooltip-example-container signature-example-container">
        <p className="tool-item-tooltip-title">Example:</p>
        <p className="tool-item-tooltip-description">Add your signature</p>
        <img
          className="signature-tooltip-example-signature"
          src="/images/self-serve-builder/toolbox/signature-icon-example-signature-2x.png"
          alt="signature example"
        />
      </div>
      )}
    type={SelfServeBuilderPopupTypes.SIGNATURE}
  />;

SignatureToolItem.propTypes = {
  tooltipName: PropTypes.string.isRequired,
  toolboxRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }).isRequired,
};

export default SignatureToolItem;



// WEBPACK FOOTER //
// ./src-react/SelfServeBuilderToolbox/SignatureToolItem.jsx